<p-table [value]="allOrderTemplates">
    <ng-template pTemplate="header">
        <tr>
            <th>Name</th>
            <th>Pipeline</th>
            <th>Created By</th>
            <th>Last Modified</th>
            <th>Is Active</th>
            <th>Action</th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-template let-i="rowIndex">
        <tr>
            <td>{{ template.templateName }}</td>
            <td>{{ template.type ? template.type.name : "" }}</td>
            <td>{{ template.createdUser }}</td>
            <td>{{ template.updatedDate | date: "MM/dd/yyyy" }}</td>
            <td>{{ template.isActive ? "Yes" : "No" }}</td>
            <td class="action">
                <span class="btnBars p-mr-0" (click)="showEditOrderTemplate(template)" pTooltip="Edit" tooltipPosition="top"><i class="pi pi-pencil"></i></span>
            </td>
        </tr>
    </ng-template>
</p-table>

<p-dialog header="Template - {{ templateHeader }}" [(visible)]="displayEditSOTemplate" [modal]="true" [responsive]="true" [style]="{ width: '60vw' }">
    <div class="card">
        <div class="p-grid">
            <div class="p-col-12">
                <div class="p-grid">
                    <h6 class="p-col-4 p-mb-0 p-pl-4">Label Name</h6>
                    <h6 class="p-col p-mb-0 p-pl-4">Edit Label Name</h6>
                    <h6 style="width: 50px">View</h6>
                    <h6 class="p-mb-0" style="width: 40px" *ngIf="templateHeader == 'Sales Orders'">Pick Slip</h6>
                    <h6 class="p-mb-0" style="width: 40px" *ngIf="templateHeader == 'Sales Orders'">Pack Slip</h6>
                    <h6 style="width: 50px">Email/Print</h6>
                </div>
                <ng-container *ngFor="let section of allSectionsSO; let i = index">
                    <p-table [value]="section.labels" dataKey="id" class="editable">
                        <ng-template pTemplate="header">
                            <tr>
                                <th class="header p-col-4">
                                    <h5 style="white-space: nowrap">
                                        {{ section.name }}
                                    </h5>
                                </th>
                                <th class="header"></th>
                                <th style="width: 40px; padding-top: 0.5rem !important" class="p-text-center header">
                                    <!-- <span
                                        class="btnBars p-mr-0"
                                        (click)="addNewField(section)"
                                        style="width: 21px; height: 21px"
                                    >
                                        <i
                                            class="pi pi-plus"
                                            style="margin-top: 5px"
                                        ></i>
                                    </span> -->
                                </th>
                                <th class="p-text-center header" style="width: 40px"></th>
                                <th class="p-text-center header" style="width: 40px" *ngIf="templateHeader == 'Sales Orders'"></th>
                                <th class="p-text-center header" style="width: 40px" *ngIf="templateHeader == 'Sales Orders'"></th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-label>
                            <tr *ngIf="!label.IsHide && label.sectionId == section.id">
                                <td>
                                    {{ label.name }}
                                    <span style="color: red" *ngIf="label.movable == false">*</span>
                                </td>
                                <td pEditableColumn class="template">
                                    <input pInputText type="text" [(ngModel)]="label.labelname" />
                                </td>
                                <td class="p-text-center template">
                                    <p-checkbox *ngIf="section.code != 'labels_section'" [disabled]="!label.isMovable" [value]="label" ngDefaultControl [(ngModel)]="label.isChecked" binary="true" (onChange)="checkMax(section, $event.checked)"></p-checkbox>
                                    <p-checkbox *ngIf="section.code == 'labels_section'" [disabled]="!label.isMovable || (!label.isChecked && maxSectionNo)" [value]="label" ngDefaultControl [(ngModel)]="label.isChecked" binary="true" (onChange)="checkSectionMax(section, $event.checked)"></p-checkbox>
                                </td>
                                <td class="p-text-center template" *ngIf="templateHeader == 'Sales Orders'">
                                    <p-checkbox [value]="label" binary="true" ngDefaultControl [(ngModel)]="label.IsPick"></p-checkbox>
                                </td>
                                <td class="p-text-center template" *ngIf="templateHeader == 'Sales Orders'">
                                    <p-checkbox [value]="label" binary="true" ngDefaultControl [(ngModel)]="label.IsPack"></p-checkbox>
                                </td>
                                <td class="p-text-center template">
                                    <p-checkbox [value]="label" ngDefaultControl [(ngModel)]="label.IsPrint" binary="true"></p-checkbox>
                                </td>
                            </tr>
                        </ng-template>
                    </p-table>
                </ng-container>
            </div>
        </div>
    </div>
    <p-footer>
        <button type="button" pButton (click)="displayEditSOTemplate = false" label="Cancel" class="p-button-secondary"></button>
        <button type="button" pButton label="Save" (click)="updateSOTemplate(templateSOTemp, allSectionsSO)"></button>
    </p-footer>
</p-dialog>

<p-dialog header="Add New Field" [modal]="true" [(visible)]="displayAddNewField" [style]="{ width: '50vw' }" [baseZIndex]="10000">
    <div class="p-grid">
        <div class="p-col-12">
            <label for="name">Name<span style="color: red">*</span></label>
            <p-dropdown appendTo="body" [options]="fieldTypesDD" optionLabel="labelname" [ngModelOptions]="{ standalone: true }" [(ngModel)]="selectedFieldType" placeholder="Select Field"></p-dropdown>
        </div>
    </div>
    <ng-template pTemplate="footer">
        <button pButton (click)="displayAddNewField = false" label="Cancel" class="p-button-secondary"></button>
        <button pButton (click)="saveField(tempField)" label="Save" [disabled]="errRepeat"></button>
    </ng-template>
</p-dialog>
